import { Modal } from "antd";
import FooterModal from "components/Button/FooterModal";
import { useForm } from "react-hook-form";
import FormAssinaturas, { AssinaturasItem } from "./FormAssinaturas";
import { Box } from "@chakra-ui/react";

interface ModalAssinaturasRelatorioProps {
  isOpenModal: boolean;
  onClose: () => any;
  onSubmit: (assinaturas: AssinaturasItem[]) => any;
  childrenComponent?: React.ReactNode;
  onExportAgrupadoPdf?: (assinaturas: AssinaturasItem[]) => Promise<void>;
  agruparPdfConta?: boolean;
}

function ModalAssinaturasRelatorio({
  isOpenModal,
  onClose,
  onSubmit,
  childrenComponent,
  onExportAgrupadoPdf,
  agruparPdfConta,
}: ModalAssinaturasRelatorioProps) {
  const { setValue, control, watch, handleSubmit } = useForm<{
    assinaturas: AssinaturasItem[];
  }>();

  const _onSubmit = ({ assinaturas }: { assinaturas: AssinaturasItem[] }) => {
    onSubmit(assinaturas);
  };
  const _onExportAgrupadoPdf = ({
    assinaturas,
  }: {
    assinaturas: AssinaturasItem[];
  }) => {
    onExportAgrupadoPdf?.(assinaturas);
  };

  const assinaturas = watch("assinaturas");
  return (
    <Modal
      centered
      visible={isOpenModal}
      footer={
        <FooterModal
          buttonCancelarText="Cancelar"
          onClose={onClose}
          onSubmit={
            agruparPdfConta
              ? handleSubmit(_onExportAgrupadoPdf)
              : handleSubmit(_onSubmit)
          }
          primaryButtonText={"Exportar"}
          showRegisterAnother={false}
        />
      }
      onCancel={onClose}
      destroyOnClose
      width="800px"
      title="Adicionar assinaturas ao relatório"
      closable={true}
    >
      <Box mt={-4}>
        <Box mb={4}>{childrenComponent}</Box>
        <FormAssinaturas
          setValue={setValue}
          formAssinaturas={assinaturas}
          control={control}
        />
      </Box>
    </Modal>
  );
}

export default ModalAssinaturasRelatorio;
